import car from '../styles/images/car.png';
import ms from '../styles/images/ms.png';
import googl from '../styles/images/googl.png';
import eyeShown from '../styles/images/eyeShown.png';
import eyeHidden from '../styles/images/eyeHidden.png';
export default /* @ngInject */ function($routeProvider, configProvider) {

    if (!configProvider.signupEnabled) {
        return;
    }

    $routeProvider.when('/signup/terms', {
        templateUrl: '/signup-basic/account/terms.html',
        title: 'Blippar Services Terms and conditions'
    });

    $routeProvider.when('/signup/terms/computer-vision', {
        templateUrl: '/signup-basic/account/computer-vision-terms.html',
        title: 'Terms and conditions'
    });

    $routeProvider.when('/signup/free', {
        templateUrl: '/signup-basic/account/account.html',
        controller: 'SignupBasicAccountCtrl',
        plansTitle: 'Pricing',
        title: 'SIGN UP',
        controllerAs: 'account',
        car: car,
        ms: ms,
        googl: googl,
        eyeShown: eyeShown,
        eyeHidden: eyeHidden,
        restrictAuthenticated: false
    });

    $routeProvider.when('/signup/free/confirmation', {
        templateUrl: '/signup-basic/confirmation/confirmation.html',
        controller: 'SignupBasicConfirmationCtrl',
        title: 'Confirm your email',
        controllerAs: 'confirmation',
        restrictAuthenticated: false
    });

}



// WEBPACK FOOTER //
// ./signup-basic/signup-basic-routes.js